import HomeTeacherList from './HomeTeacherList';

export default HomeTeacherList;